export default {
  "init":"測試",
  "intro" : "簡介",
  "contact" : "聯絡",
  "resume" : "履歷",
  "project" : "項目",
  "copied" : "已複製到剪貼簿",

  "westKowloonTitle" : "西九文化區應用程式",
  "westKowloonDescription" : "- 地理定位<br/>- 虛擬路牌<br/>- Instagram AR 特效",
  "hkriTitle" : "愉景灣繽紛復活節2021",
  "hkriDescription" : "- 網頁AR<br/>- 地理定位<br/>- 尋寶地圖",
  "metrohitTitle" : "新城勁爆AR 合拍體驗",
  "metrohitDescription" : "- 網頁AR<br/>- 歌手合照",
  "shs618Title" : "上海街 618",
  "shs618Description" : "- 網頁AR<br/>- Facebook , Instagram AR 特效",
  "taiOTitle" : "AR 深遊大澳",
  "taiODescription" : "- 網頁AR<br/>- 虛擬路牌<br/>- 拍照",
  "fhkcccTitle" : "盂蘭節 目連救母",
  "fhkcccDescription" : "- VR 遊戲",
   "csassTitle" : "青玉案 (元夕)",
  "csassDescription" : "- VR 遊戲",
  "AQTitle" : "AR 水族館",
  "AQDescription" : "- 填色 AR 互動<br/>- 多人遊戲",
  "ar101Title" : "101AR",
  "ar101Description" : "- 產品<br/>- 自訂 AR 教學與學習體驗",
  "ssTitle" : "手機多人互動遊戲",
  "ssDescription" : "網頁控制器",
  "vendingTitle" : "互動紀念品機",
  "vendingDescription" : "- 以 Facebook like 觸發",
  "vsTitle" : "Vidal Sassoon",
  "vsDescription" : "- AR, 人臉識別, 產品識別",
  "skiiTitle" : "SK-II",
  "skiiDescription" : "互動產品介紹",
  "oralBTitle" : "Oral-B",
  "oralBDescription" : "互動產品介紹",
  "jureTitle" : "卓爾珠寶",
  "jureDescription" : "互動產品介紹",
  "vehicleTitle" : "車輛電子目錄",
  "vehicleDescription" : "互動產品介紹",
  "ive2Title" : "IVE 香港職業訓練局",
  "ive2Description" : "互動教學",
  "ive1Title" : "IVE 香港職業訓練局",
  "ive1Description" : "互動教學",
  "towngasTitle" : "香港中華煤氣公司",
  "towngasDescription" : "互動產品介紹",
  "ggjTitle" : "Ouija Sequence",
  "ggjDescription" : "Global Game Jam 2016 <br/> 最佳主題整合",
}



// WEBPACK FOOTER //
// ./src/language/tc.js